import { useContext } from 'react';

import { SingleSelectContext } from '../../components/single-select/single-select.context';
import { SingleSelectContextType } from '../types/stateful-list.types';

export function useSingleSelect() {
  const ctx = useContext(SingleSelectContext);
  if (!ctx) throw new Error('useSingleSelect must be used within List.SingleSelect');
  return ctx as SingleSelectContextType;
}
